import { create } from 'zustand';

export const useBusinessStore = create((set, get) => ({
  activeBusinessId: null,
  masterDb: [],
  plansDb: [],
  activeTab: 'master-dashboard',
  adminEmails: [],

  setActiveBusinessId: (id) => set({ activeBusinessId: (id === null || id === undefined) ? null : String(id) }),
  setMasterDb: (updater) => set((state) => ({ 
    masterDb: typeof updater === 'function' ? updater(state.masterDb) : updater 
  })),
  setPlansDb: (db) => set({ plansDb: db }),
  setActiveTab: (tab) => set({ activeTab: tab }),
  setAdminEmails: (emails) => set({ adminEmails: emails }),

  // Helper selector
  getActiveBusiness: () => {
    const state = get();
    return state.masterDb.find(b => String(b.id) === String(state.activeBusinessId)) || null;
  }
}));
